module.exports = __webpack_public_path__ + "img/pattern-bg.d0cd8837.jpg";